import request from '@/utils/request'
export const pageListApi = (data) => {
    return request({
        url: '/UserRewardsRedemptions/List',
        method: 'post',
        data
    })
}

export const getUserApi = (data) => {
    return request({
        url: 'Users/XList',
        method: 'post',
        data
    })
}

export const getGoodApi = (data) => {
    return request({
        url: 'Rewards/homeList',
        method: 'post',
        data
    })
}

export const addApi = (data) => {
    return request({
        url: '/UserRewardsRedemptions/save',
        method: 'post',
        data
    })
}